import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getExpenseTemplates(agencyId: number) {
  const data = await apiGet(`helper/expenseTemplates/agencyId/${agencyId}`);

  useHelperStore().setExpenseTemplates({ agencyId, data });
}
